var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <h1> Valitse lähtöpaikka </h1> <form name=\"form\"> <div class=\"row\"> <div class=\"col-xs-12\"> <bus-select container-class=\"bus-picker\" icon-class=\"search-icon fa fa-bus\" ng-model=\"$ctrl.stopID\" dep-dest-code=\"{{ $ctrl.resolve.depDestCode }}\" dep-begin-date=\"{{ $ctrl.resolve.depBeginDate }}\" dep-end-date=\"{{ $ctrl.resolve.depEndDate }}\"> </bus-select> </div> </div> <div class=\"row\"> <div class=\"col-xs-offset-8 col-xs-4\"> <button type=\"button\" class=\"btn btn-default form-control\" ng-click=\"$ctrl.go()\" ng-disabled=\"!form.$valid\">Valitse</button> </div> </div> </form> </web-component>";
var id1="winresAskStop.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresAsk/winresAskStop.html
// module id = 306
// module chunks = 2